import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../components/nav/Footer.js';
import '../styles/contact-pages.css';
import content from '../assets/content.json';

export default function ContactPageFree() {
  const navigate = useNavigate();

  useEffect(() => {
    const FORM_TARGET = "#hubspot-form-wrapper";

    const loadForm = () => {
      const wrapper = document.querySelector(FORM_TARGET);
      if (wrapper) wrapper.innerHTML = "";

      let attempts = 0;
      const maxAttempts = 20;

      const interval = setInterval(() => {
        if (window.hbspt?.forms) {
          window.hbspt.forms.create({
            region: "na1",
            portalId: "50260926",
            formId: "fffef7a0-7421-401d-bf70-975cba5c8d04",
            target: FORM_TARGET,
          });
          clearInterval(interval);
        } else if (attempts > maxAttempts) {
          clearInterval(interval);
          console.error("HubSpot script did not initialize in time");
        }
        attempts++;
      }, 300);
    };

    loadForm();

    const onPageShow = (event) => {
      if (event.persisted) {
        loadForm();
      }
    };

    window.addEventListener("pageshow", onPageShow);

    return () => {
      window.removeEventListener("pageshow", onPageShow);
    };
  }, [navigate]);

  const freeContent = content.contactPageFree;

  return (
    <HelmetProvider>
      <Helmet>
        <title>{content.metadata.contactPageFreeMetadata.title}</title>
        <meta name="description" content={content.metadata.contactPageFreeMetadata.description} />
      </Helmet>
      <div>
        <div className="claims-form-wrapper">
          <div className="claims-form-splash">
            <div className="logo-wrapper">
              <Link to="/">
                <img
                  src={`${process.env.PUBLIC_URL}/images/logos/logo-top.png`}
                  alt="TrustPro Logo"
                />
              </Link>
            </div>
            <div className="claims-splash-text">
              {freeContent.headerOne && (
                <p className="claims-header-one">{freeContent.headerOne}</p>
              )}
              {freeContent.subHead && (
                <p className="claims-subhead">{freeContent.subHead}</p>
              )}
            </div>
          </div>
          <div className="claims-content-background">
            <div className="claims-content">
              <div className="text-column">
                {freeContent.introSections?.map((section, i) => (
                  <div key={`intro-${i}`} className="intro-section">
                    {section.sectionTitle && <h2>{section.sectionTitle}</h2>}
                    {section.paragraphs?.map((p, idx) => (
                      <p key={idx}>{p}</p>
                    ))}
                  </div>
                ))}
                {freeContent.listSections?.map((section, sectionIndex) => (
                  <div key={`list-${sectionIndex}`} className="list-section">
                    {section.sectionTitle && (<h3 className="list-section-title">{section.sectionTitle}</h3>)}
                    {section.sectionIntro && (<p className="list-section-text">{section.sectionIntro}</p>)}

                    {section.listType === "number" ? (
                      <ol>
                        {section.sectionItems?.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ol>
                    ) : (
                      <ul>
                        {section.sectionItems?.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
                {freeContent.subHeadTwo && (
                  <h2 className="claims-subhead-two">{freeContent.subHeadTwo}</h2>
                )}
              </div>
              <div className="form-column">
                <div className="claims-form">
                  <div id="hubspot-form-wrapper"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </HelmetProvider>
  );
}
